import { useTranslation } from 'react-i18next';
import { PagePath } from '@zep/common/routes';
import { Button, Stack } from '@zep/ui';
import { cn } from '@zep/utils';
import S from './MapTemplateModal.module.scss';
interface MapTemplatesEmptyProps {
  isPurchasedMap?: boolean;
  variant?: 'modal' | 'page';
}
export const MapTemplatesEmpty = ({
  isPurchasedMap = true,
  variant = 'modal'
}: MapTemplatesEmptyProps) => {
  const {
    t
  } = useTranslation(['common']);
  const containerClass = variant === 'page' ? 'flex min-h-[718px] w-full flex-col items-center justify-center gap-[24px]' : S.empty_content;
  const textContainerClass = variant === 'page' ? 'flex flex-col items-center justify-center gap-[4px]' : S.empty_content_text;
  return <Stack gap={24} className={containerClass} data-sentry-element="Stack" data-sentry-component="MapTemplatesEmpty" data-sentry-source-file="MapTemplateFallbacks.tsx">
      <img src="/images/empty-purchased-asset.png" alt="empty purchased asset" width="88" height="60" />
      <div className={textContainerClass}>
        <p className={variant === 'page' ? 'text-h4 font-700 text-center text-gray-900' : ''}>
          {isPurchasedMap ? t('common:mapTemplateModal.emptyContent.noItems') : '해당하는 템플릿이 없습니다.'}
        </p>
        <p className={variant === 'page' ? 'text-subtitle font-medium text-gray-600' : S.subtitle}>
          {isPurchasedMap ? t('common:mapTemplateModal.emptyContent.goAssetStore') : '적용된 필터를 조절하거나, 초기화해 주세요.'}
        </p>
      </div>
      {isPurchasedMap && <Button as="a" size={variant === 'page' ? 'md' : 'sm'} children={t('common:mapTemplateModal.emptyButtonText')} href={PagePath.AssetStore} target="_blank" />}
    </Stack>;
};
export const MapTemplatesSkeleton = () => {
  return <div className={cn('flex flex-col', S.content)} data-sentry-component="MapTemplatesSkeleton" data-sentry-source-file="MapTemplateFallbacks.tsx">
      {Array.from({
      length: 6
    }).map((_, index) => <div key={index} className="flex w-full gap-[12px] rounded-[8px] p-[4px]">
          <div className="h-[85px] w-[132px] shrink-0 rounded bg-gray-200" />
          <div className="flex flex-1 flex-col justify-center gap-2">
            <div className="h-3 w-1/3 rounded bg-gray-200" />
            <div className="h-4 w-2/3 rounded bg-gray-200" />
          </div>
        </div>)}
    </div>;
};